import React from "react";
import t from "../../../../helpers/t";
import Biscuit from "../../../../../utils/Biscuit";

const NewMessageButtton = (props) => {
  return (
    <>
      <a
        href={props.url}
        id="inb-c-left-bar-add-user"
        className={"button beautify beautify-" + Biscuit.get("user.client_id")}
      >
        <i className="fi fi-page-add"></i>
        <span>{t("add_${a}", { a: t("message", null, "capital") })}</span>
      </a>
    </>
  );
};
export default NewMessageButtton;
